import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
// mock
import CadastroDespesaForm from '../FormsTemplates/Despesa/CadastroDespesaForms';
import CadastroDespesaPorTipoForm from '../FormsTemplates/Despesa/CadastroDespesaPorTipoForms';

export default function CadDespesa() {
  
  const validaTipoComercio = localStorage.getItem(['tipo_comercio']);
  const tipoComercio = parseInt(validaTipoComercio, 10);
  const CadastroDespesa = tipoComercio === 5 ? CadastroDespesaPorTipoForm : CadastroDespesaForm;

  return (
    <Page title="Despesa">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Cadastro de Despesa
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/despesa/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <CadastroDespesa/>    
      </Container>
    </Page>
  );
}
